import React from "react";
import { Redirect } from "react-router-dom";
import * as messages from "../../shared/messages";

import * as routes from "../../shared/routes";

const error = errorMessage => {
  return <div className="alert alert-danger">{ErrorMessage(errorMessage)}</div>;
};

const ErrorMessage = message => {
  if (message === messages.Unauthorized) {
    return (
       <Redirect to={routes.sessionExpired} />     
    );
  }

  return <span>{message}</span>;
};

export default error;
